module.exports = __webpack_public_path__ + "img/ic_share_fb.6382ffd.svg";